import React from "react";
import { Link } from "react-router-dom";
import LogoAtivaJa from "@/components/LogoAtivaJa";
import { Check, Phone } from "lucide-react";

const STEPS = ["Localizar", "Confirmar", "Agendar", "Avaliar"];

export const ClienteStepper = ({ step = 0 }) => (
  <div className="flex items-center" data-testid="cliente-stepper">
    {STEPS.map((label, i) => {
      const done = i < step;
      const current = i === step;
      return (
        <React.Fragment key={label}>
          <div className="flex items-center gap-2">
            <div
              className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-colors ${
                done
                  ? "bg-[#142766] text-white"
                  : current
                  ? "bg-gradient-to-br from-[#FF6700] to-[#F97316] text-white shadow-[0_4px_12px_-4px_rgba(234,88,12,.6)]"
                  : "bg-[#F1F5F9] text-[#94A3B8] border border-[#E2E8F0]"
              }`}
              data-testid={`stepper-step-${i}`}
            >
              {done ? <Check size={14} strokeWidth={3} /> : i + 1}
            </div>
            <span
              className={`text-xs font-semibold hidden sm:block ${
                current ? "text-[#FF6700]" : done ? "text-[#142766]" : "text-[#94A3B8]"
              }`}
            >
              {label}
            </span>
          </div>
          {i < STEPS.length - 1 && (
            <div className={`flex-1 h-[2px] mx-2 sm:mx-3 rounded ${i < step ? "bg-[#142766]" : "bg-[#E2E8F0]"}`} />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default function ClienteShell({ step = 0, children, headerRight = null }) {
  return (
    <div className="min-h-screen bg-[#F8FAFC] font-body flex flex-col">
      <header className="bg-white border-b border-[#E2E8F0] sticky top-0 z-20">
        <div className="max-w-2xl mx-auto px-5 py-3.5 flex items-center justify-between">
          <Link to="/" data-testid="cliente-logo-link">
            <LogoAtivaJa size="sm" />
          </Link>
          {headerRight || (
            <Link
              to="/login"
              className="text-sm font-semibold text-[#142766] hover:text-[#FF6700] transition-colors"
              data-testid="cliente-sou-prestador"
            >
              Sou prestador
            </Link>
          )}
        </div>
        <div className="max-w-2xl mx-auto px-5 pb-3.5">
          <ClienteStepper step={step} />
        </div>
      </header>
      <main className="max-w-2xl w-full mx-auto px-5 py-10 flex-1">{children}</main>
      <footer className="border-t border-[#E2E8F0] bg-white">
        <div className="max-w-2xl mx-auto px-5 py-4 text-xs text-[#94A3B8] flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>Portal do Cliente · MontaJá</span>
          <a href="https://wa.me/5511939387366" target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-1.5 font-semibold text-[#142766] hover:text-[#FF6700] transition-colors"
            data-testid="cliente-contato-ativaja">
            <Phone size={12} /> MontaJá: (11) 93938-7366
          </a>
        </div>
      </footer>
    </div>
  );
}
